import { render, staticRenderFns } from "./SectionPage.vue?vue&type=template&id=3970da10&"
import script from "./SectionPage.vue?vue&type=script&lang=js&"
export * from "./SectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3970da10')) {
      api.createRecord('3970da10', component.options)
    } else {
      api.reload('3970da10', component.options)
    }
    module.hot.accept("./SectionPage.vue?vue&type=template&id=3970da10&", function () {
      api.rerender('3970da10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SectionPage.vue"
export default component.exports